<template>
  <div class="risk-mailbox">
    <loading v-if="!$store.state.productLoading"></loading>
    <not-available v-else-if="availableProducts.length === 0" title="邮箱画像"></not-available>
    <div v-else class="risk-mailbox-content">
      <div class="risk-mailbox-header">
        <h3 v-if="availableProducts.length === 1">{{ selectedProduct.label }}</h3>
        <div v-else class="product-select" @click="toggleProducts">
          <span>
            {{ selectedProduct.label }}
            <i class="iconfont iconsanjiaoxingbeifen" :class="{ active: showProducts }"></i>
          </span>
          <ul v-if="showProducts" class="product-select-list">
            <li
              v-for="item in availableProducts"
              :key="item.value"
              :class="{ active: type === item.value }"
              @click.stop="selectProduct(item.value)"
            >{{ item.label }}</li>
          </ul>
        </div>
      </div>
      <component :is="selectedProduct.component"></component>
    </div>
  </div>
</template>

<script>
import NotAvailable from '../../components/mark/notAvailable'
import RiskMailboxOnline from './components/RiskMailboxOnline'
import RiskMailboxOffline from './components/RiskMailboxOffline'

export default {
  name: 'RiskMailbox',
  components: { NotAvailable, RiskMailboxOnline, RiskMailboxOffline },
  data () {
    return {
      showProducts: false,
      type: '',
      products: [
        {
          label: '邮箱画像-在线API版本',
          value: 'black_mailbox_online',
          component: 'RiskMailboxOnline'
        },
        {
          label: '邮箱画像-私有化版本',
          value: 'black_mailbox_offline',
          component: 'RiskMailboxOffline'
        }
      ]
    }
  },
  methods: {
    toggleProducts () {
      this.showProducts = !this.showProducts
    },
    selectProduct (type) {
      this.type = type
      this.showProducts = false
    }
  },
  computed: {
    availableProducts () {
      const codes = this.$store.state.product.map(item => item.busi)
      return this.products.filter(item => codes.includes(item.value))
    },
    selectedProduct () {
      return this.availableProducts.find(item => item.value === this.type) || this.availableProducts[0] || {}
    }
  },
  watch: {
    availableProducts: {
      immediate: true,
      handler (products) {
        if (!products.length) return
        const routeType = this.$route.params.busi
        const requested = products.find(item => item.value === routeType)
        if (!products.find(item => item.value === this.type)) {
          this.type = requested ? requested.value : products[0].value
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.risk-mailbox {
  min-height: 100%;
  padding: 30px 40px 48px;
  box-sizing: border-box;
}

.risk-mailbox-header {
  display: flex;
  align-items: center;
  min-height: 32px;
  margin-bottom: 24px;

  h3 {
    font-size: 18px;
    font-weight: 500;
    color: #1d243c;
  }

  .product-select {
    position: relative;
    color: #1d243c;
    font-size: 18px;
    font-weight: 500;
    line-height: 30px;
    cursor: pointer;

    i {
      display: inline-block;
      margin-left: 8px;
      transform: rotate(90deg);

      &.active {
        transform: rotate(270deg);
      }
    }
  }

  .product-select-list {
    position: absolute;
    top: 38px;
    left: 0;
    z-index: 99;
    width: 100%;
    min-width: 290px;
    padding: 12px 0;
    background: #fff;
    box-shadow: 0 4px 8px rgba(17, 39, 98, 0.04);

    li {
      height: 40px;
      padding-left: 20px;
      color: #1d243c;
      font-size: 16px;
      font-weight: 400;
      line-height: 40px;
      text-align: left;

      &:hover,
      &.active {
        background: #dceaff;
      }
    }
  }
}

@media (max-width: 768px) {
  .risk-mailbox {
    padding: 20px 16px 36px;
  }

  .risk-mailbox-header {
    .product-select,
    .product-select-list {
      width: 100%;
      min-width: 0;
    }
  }
}
</style>
